import { ItemLayoutType } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitTimeKeeping/types';

// Re-places items row by row within the new cols count, preserving visual order.
// Only called when at least one item overflows (x + w > cols).
export const reflowItems = (items: ItemLayoutType[], cols: number): ItemLayoutType[] => {
  const sorted = [...items].sort((a, b) => (a.y !== b.y ? a.y - b.y : a.x - b.x));
  const result: ItemLayoutType[] = [];
  let curX = 0;
  let curY = 0;
  let rowH = 0;
  for (const item of sorted) {
    const w = Math.min(item.w, cols);
    if (curX + w > cols) {
      curX = 0;
      curY += rowH;
      rowH = 0;
    }
    result.push({ ...item, x: curX, y: curY });
    curX += w;
    if (item.h > rowH) rowH = item.h;
  }
  return result;
};
